import React from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";

/**
 * Geographically accurate India map.
 * Uses react-simple-maps with state-level GeoJSON (public domain, amCharts).
 * City pins are placed with REAL latitude/longitude — react-simple-maps
 * projects them automatically so every label sits on its true location.
 */

const CITIES = [
  { name: "Srinagar", coords: [74.79, 34.08], align: "right" },
  { name: "New Delhi", coords: [77.21, 28.61], align: "right" },
  { name: "Jaipur", coords: [75.78, 26.92], align: "left" },
  { name: "Lucknow", coords: [80.95, 26.85], align: "right" },
  { name: "Ahmedabad", coords: [72.58, 23.03], align: "left" },
  { name: "Kolkata", coords: [88.36, 22.57], align: "right" },
  { name: "Mumbai", coords: [72.87, 19.07], align: "left" },
  { name: "Hyderabad", coords: [78.49, 17.39], align: "right" },
  { name: "Bengaluru", coords: [77.59, 12.97], align: "left" },
  { name: "Chennai", coords: [80.27, 13.08], align: "right" },
  { name: "Guwahati", coords: [91.74, 26.14], align: "right" },
];

const PROJECTION_CONFIG = {
  scale: 1000,
  center: [82, 22.5],
};

export default function IndiaMap() {
  return (
    <div data-testid="india-map" className="relative w-full h-full">
      <ComposableMap
        projection="geoMercator"
        projectionConfig={PROJECTION_CONFIG}
        width={500}
        height={580}
        style={{ width: "100%", height: "100%" }}
      >
        <Geographies geography="/india-geo.json">
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill="#F2E8CF"
                stroke="#D4AF37"
                strokeWidth={0.6}
                style={{
                  default: { outline: "none" },
                  hover: { fill: "#EBD685", outline: "none" },
                  pressed: { outline: "none" },
                }}
                data-testid="india-map-outline"
              />
            ))
          }
        </Geographies>

        {CITIES.map((c) => (
          <Marker
            key={c.name}
            coordinates={c.coords}
            data-testid={`india-pin-${c.name.toLowerCase().replace(/\s/g, "-")}`}
          >
            <circle r={9} fill="#D4AF37" fillOpacity={0.2}>
              <animate
                attributeName="r"
                values="6;13;6"
                dur="2.6s"
                repeatCount="indefinite"
              />
              <animate
                attributeName="fill-opacity"
                values="0.3;0;0.3"
                dur="2.6s"
                repeatCount="indefinite"
              />
            </circle>
            <circle r={3.5} fill="#D4AF37" stroke="#2A221A" strokeWidth={1} />
            <text
              x={c.align === "right" ? 7 : -7}
              y={3}
              textAnchor={c.align === "right" ? "start" : "end"}
              fontSize={9}
              fontFamily="Manrope, sans-serif"
              fontWeight={600}
              fill="#2A221A"
              style={{ paintOrder: "stroke", stroke: "white", strokeWidth: 2.5 }}
            >
              {c.name}
            </text>
          </Marker>
        ))}
      </ComposableMap>
    </div>
  );
}
